import { apiClient } from './api';
import { API_ENDPOINTS, APIHeadersWithAuth } from '../globalConstants';
import type { Purchase, PurchaseItem } from '@/lib/types';

export interface PurchaseInput {
    vendorId?: string;
    items: PurchaseItem[];
    paidAmount: number;
    paymentMethod?: string;
}

export async function listPurchases(shopId: number | string): Promise<Purchase[]> {
    const res = await apiClient.get<{ data: any[] }>(
        API_ENDPOINTS.purchases.LIST(shopId),
        { headers: APIHeadersWithAuth() }
    );
    return res.data;
}

export async function getPurchase(
    shopId: number | string,
    id: number | string
): Promise<Purchase> {
    const res = await apiClient.get<{ data: any }>(
        API_ENDPOINTS.purchases.GET(shopId, id),
        { headers: APIHeadersWithAuth() }
    );
    return res.data;
}

export async function createPurchase(
    shopId: number | string,
    input: PurchaseInput
): Promise<Purchase> {
    const res = await apiClient.post<{ data: any }>(
        API_ENDPOINTS.purchases.CREATE(shopId),
        {
            vendorId: input.vendorId,
            items: input.items.map((i) => ({
                productId: i.productId,
                materialId: (i as any).materialId,
                itemName: i.itemName,
                quantity: i.quantity,
                unitPrice: i.unitPrice,
            })),
            paidAmount: input.paidAmount,
            paymentMethod: input.paymentMethod,
        },
        { headers: APIHeadersWithAuth() }
    );
    return res.data;
}

export async function payPurchase(
    shopId: number | string,
    id: number | string,
    amount: number,
    method?: string
): Promise<Purchase> {
    const res = await apiClient.post<{ data: any }>(
        API_ENDPOINTS.purchases.PAY(shopId, id),
        method ? { amount, paymentMethod: method } : { amount },
        { headers: APIHeadersWithAuth() }
    );
    return res.data;
}

export async function deletePurchase(
    shopId: number | string,
    id: number | string
): Promise<void> {
    await apiClient.delete(API_ENDPOINTS.purchases.DELETE(shopId, id), {
        headers: APIHeadersWithAuth(),
    });
}
